"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var iconMap_1 = __importDefault(require("./iconMap"));
exports.default = (function (kind) { return iconMap_1.default[kind]; });
